var map = {
	"./chocolate-fictional/sustainability_environmental.json": [
		1595,
		[
			1595
		]
	],
	"./chocolate/sustainability_environmental.json": [
		5527,
		[
			5527
		]
	],
	"./hemas-clogard/sustainability_environmental.json": [
		8122,
		[
			8122
		]
	],
	"./linqOne/sustainability_environmental.json": [
		2727,
		[
			2727
		]
	],
	"./munchee-tikiri-marie/sustainability_environmental.json": [
		9258,
		[
			9258
		]
	],
	"./shan-teas/sustainability_environmental.json": [
		477,
		[
			477
		]
	],
	"./wipotech-chocolates/sustainability_environmental.json": [
		4908,
		[
			4908
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2762;
module.exports = webpackAsyncContext;